<!-- <mat-card>
    <mat-card-header>
        <mat-card-title>Registro</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        
        <p>
                    
            <input type="text" placeholder="nombre" [(ngModel)]="nombre">
        
        </p>
        <p>
            
            <input type="text" placeholder="email" [(ngModel)]="email">
            
        </p>
        <p>
            
            <input type="password" placeholder="Password" [(ngModel)]="password">
            
        </p>
        <button type="submit" color="primary" (click)="onAddUser()">Registrarse</button>
    </mat-card-content>
   
</mat-card> -->

<mat-card>
    <mat-card-header>
        <mat-card-title>Registrate!</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onAddUser(loginForm.value)">

            <p>
                <mat-form-field>
                    <input type="text" matInput placeholder="Nombre de Usuario" formControlName="nombre">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field>
                    <input type="text" matInput placeholder="e-mail" formControlName="email">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field>
                    <input type="password" matInput placeholder="Password" formControlName="password">
                </mat-form-field>
            </p>
           
            <button type="submit" mat-raised-button style="background-color: green;">Ingresar</button>
            <br>
            <br>

            <button style="background-color: rgb(150, 8, 8);" mat-raised-button (click)="login()">Ir al Login</button>
        </form>
    </mat-card-content>
   
</mat-card>